/* eslint-disable max-lines */
import { menchantNotOnboarding } from '../../utils/api';
import { filterBuilder } from '../../utils/builder/settingDataMerchant';
import { actionTypes } from './constants';
import { initialState } from './reducer';

export function setFailedAction({ key, message, error, data }) {
  return { type: actionTypes.FAILED, key, message, error, data };
}

export function setLoadingAction({ key, loading = true }) {
  return { type: actionTypes.LOADING, key, loading };
}

export function setSuccessAction({
  key,
  data,
  meta = {},
  initial = true,
  message = '',
  success = true,
}) {
  return {
    type: actionTypes.SUCCESS,
    key,
    data,
    meta,
    initial,
    message,
    success,
  };
}

export function setFilterAction({ key, filter = {} }) {
  return { type: actionTypes.FILTER, key, filter };
}

export function setMessageAction({ key, message }) {
  return { type: actionTypes.MESSAGE, key, message };
}

export function setFormAction({ key, form }) {
  return { type: actionTypes.FORM, key, form };
}

export function fetchMerchantNotOnboardList({
  nextPage = 1,
  search = '',
  filter = initialState.table.filter,
  initial = true,
}) {
  return async (dispatch, getState) => {
    const key = 'table';
    const state = getState();
    const { page, totalPage } = state?.merchantNotOnboard?.[key]?.meta || { page: 0, totalPage: 0 };
    if (!initial && page > 1 && page >= totalPage) {
      return;
    } else {
      try {
        const params = {
          ...filter,
          search,
          size: 100,
          page: nextPage,
        };
        dispatch(setLoadingAction({ key }));
        const response = await menchantNotOnboarding(filterBuilder(params));
        const data = initial
          ? response.data
          : [...state.merchantNotOnboard[key].data, ...response.data];
        dispatch(setSuccessAction({ key, data, meta: response.meta, initial }));
        dispatch(setFailedAction({ key: 'resend', message: '', error: {} }));
        dispatch(clearRedux());
      } catch (error) {
        const { message } = error;
        dispatch(setFailedAction({ key, message }));
      }
    }
  };
}

export function setMerchantNotOboardListFilter(filter) {
  return async (dispatch) => {
    dispatch(
      setFilterAction({
        key: 'table',
        filter,
      })
    );
  };
}

export const clearRedux = () => {
  return async (dispatch) => {
    dispatch(setSuccessAction({ key: 'bank', data: {}, message: '' }));
    dispatch(setSuccessAction({ key: 'agen', data: {}, message: '' }));
    dispatch(setFailedAction({ key: 'agen', message: '' }));
    dispatch(setFailedAction({ key: 'identity', message: '' }));
    dispatch(setFailedAction({ key: 'sync', message: '' }));
  };
};
